<div class="d-flex flex-column gap-2">
    <div class="d-flex justify-content-between">
        <div>
            {{'Extractor Stats for'|translate}}
            <div class="fw-bold f-size-11em">{{data.accountName}}</div>
            <div class="fw-bold">{{data.clientName}}</div>
        </div>
        <button class="btn-close btn-close-white align-self-start" (click)="snackBarRef.dismissWithAction()"></button>
    </div>
    <div *ngIf="data.metadata.imgsSupported" class="d-flex justify-content-between align-items-baseline">
        <div class="title">{{'Extracted Checks'|translate}}</div>
        <div class="fw-bold f-size-12em"
             [ngClass]="{'text-danger': data.metadata.imgsExtracted === 0, 'text-success': data.metadata.imgsExtracted > 0}">
            {{data.metadata.imgsExtracted}}
        </div>
    </div>
    <div *ngIf="data.metadata.stmtsSupported" class="d-flex justify-content-between align-items-baseline">
        <div class="title">{{'Extracted Statements'|translate}}</div>
        <div class="fw-bold f-size-12em"
             [ngClass]="{'text-danger': data.metadata.stmtsExtracted === 0, 'text-success': data.metadata.stmtsExtracted > 0}">
            {{data.metadata.stmtsExtracted}}
        </div>
    </div>
    <div *ngIf="data.metadata.txSupported" class="d-flex justify-content-between align-items-baseline">
        <div class="title">{{'Extracted Transactions'|translate}}</div>
        <div class="fw-bold f-size-12em"
             [ngClass]="{'text-danger': data.metadata.txExtracted === 0, 'text-success': data.metadata.txExtracted > 0}">
            {{data.metadata.txExtracted}}
        </div>
    </div>
</div>